import Auth from '../api/auth';

const parseErrorCode = error => {
  // Billing block (402): surface a friendly screen instead of logging the user out.
  // Distinct from the 401 suspended path which clears auth cookies.
  if (
    error?.response?.status === 402 &&
    error?.response?.data?.error === 'billing_blocked'
  ) {
    window.dispatchEvent(
      new CustomEvent('billing:blocked', { detail: error.response.data })
    );
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
